"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INCIDENT_TYPE = void 0;
exports.INCIDENT_TYPE = {
    TO_DISPATCH: 'TO_DISPATCH',
    TO_CANCEL: 'TO_CANCEL',
    ASK_CALL: 'ASK_CALL',
    CUSTOMER_CLAIM: 'CUSTOMER_CLAIM',
    CHECKOUT_ERROR: 'CHECKOUT_ERROR',
    OVERLAPPING_TRIP: 'OVERLAPPING_TRIP',
    CHECK_DATA: 'CHECK_DATA',
    OUTSOURCING: 'OUTSOURCING',
    DOUBLON: 'DOUBLON',
    PASSENGER_ASK_CALL: 'PASSENGER_ASK_CALL',
    NO_SHOW_REQUEST: 'NO_SHOW_REQUEST',
    NO_APPROACH: 'NO_APPROACH',
    NO_PICK_UP: 'NO_PICK_UP',
    NO_DROP_OFF: 'NO_DROP_OFF',
    CANCELLATION_IN_DEDICATED_PAKCAGE: 'CANCELLATION_IN_DEDICATED_PAKCAGE',
    DRIVER_LATE: 'DRIVER_LATE',
    DRIVER_CLAIM: 'DRIVER_CLAIM',
    TEXT_MESSAGE_RECEIVED: 'TEXT_MESSAGE_RECEIVED',
    DRIVER_TO_SUSPEND: 'DRIVER_TO_SUSPEND',
};
